<template>
  <form name="form" v-on:submit.prevent="submit" v-on:change="changeHandler">
    <div class="card-body">
      <div class="col-xl-12">
        <div class="form-horizontal">
          <inputbox
            v-model="form.claim_reference"
            name="claim_reference"
            label="Claim Reference"
            :error-message="form.errors.get('claim_reference')"
            :show-error="form.errors.has('claim_reference')"
          ></inputbox>

          <div class="form-group no-margin-btm">
            <label for="referrer_type" class="control-label col-md-2"
              >Referrer Type:</label
            >
            <div class="col-md-10">
              <form-navigation-tabs
                :tabs="tabs"
                v-on:selected="setActive"
                :active="referrer_type"
              ></form-navigation-tabs>
            </div>
          </div>

          <selectlist
            :options="referrers"
            v-model="form.referrer_id"
            label="Referrer"
            label-name="name"
            placeholder="Please Select"
            name="referrers"
            v-if="showReferrer"
          ></selectlist>

          <div v-if="referrer_type == 'individual'">
            <inputbox
              v-model="form.referrer_first_name"
              name="referrer_first_name"
              label="First Name"
            ></inputbox>

            <inputbox
              v-model="form.referrer_last_name"
              name="referrer_last_name"
              label="Last Name"
            ></inputbox>

            <inputbox
              v-model="form.referrer_telephone"
              name="referrer_telephone"
              label="Telephone"
            ></inputbox>

            <inputbox
              v-model="form.referrer_email_address"
              name="referrer_email_address"
              type="email"
              label="Email Address"
            ></inputbox>
          </div>

          <inputbox
            v-model="form.source_reference"
            name="source_reference"
            label="Source Reference"
            :error-message="form.errors.get('source_reference')"
            :show-error="form.errors.has('source_reference')"
          ></inputbox>

          <div
            class="form-group"
            :class="{ 'has-error': form.errors.has('incident_occurred_at') }"
          >
            <label for="incident_occurred_at" class="col-lg-2 control-label"
              >Incident Date/Time:</label
            >
            <div class="col-lg-10">
              <datetimepicker
                :value="form.incident_occurred_at"
                :disabled="disabledDates.incident"
                v-on:selected="setIncidentDate"
                v-on:input="changeHandler"
                input-class="form-control"
              ></datetimepicker>
              <span
                class="text-danger"
                v-text="form.errors.get('incident_occurred_at')"
                v-if="form.errors.has('incident_occurred_at')"
              ></span>
            </div>
          </div>

          <div
            class="form-group"
            :class="{ 'has-error': form.errors.has('referred_at') }"
            v-if="form.incident_occurred_at"
          >
            <label for="referred_at" class="col-lg-2 control-label"
              >Date Referred:</label
            >
            <div class="col-lg-10">
              <datepicker
                format="dd/MM/yyyy"
                :value="form.referred_at"
                v-on:selected="setReferredDate"
                v-on:input="changeHandler"
                input-class="form-control"
                placeholder="dd/mm/yyyy"
                :disabled="disabledDates.referred"
              ></datepicker>
              <span
                class="text-danger"
                v-text="form.errors.get('referred_at')"
                v-if="form.errors.has('referred_at')"
              ></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer text-right">
      <button class="btn btn-primary btn-raised">Save</button>
    </div>
  </form>
</template>
<script>
export default {
  props: {
    incident: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      referrers: [],
      form: new window.Form(
        {
          claim_reference: null,
          source_reference: null,
          incident_occurred_at: null,
          referred_at: null,
          referrer_id: null,
          referrer_first_name: null,
          referrer_last_name: null,
          referrer_telephone: null,
          referrer_email_address: null
        },
        false
      ),
      source_exists: false,
      referrer_type: 'company',
      tabs: [
        {
          name: 'company',
          label: 'Company',
          disabled: false
        },
        {
          name: 'individual',
          label: 'Individual',
          disabled: false
        },
        {
          name: 'none',
          label: 'None',
          disabled: false
        }
      ],
      data_entered: false
    };
  },

  mounted() {
    this.mount();
  },

  computed: {
    showReferrer() {
      return this.referrer_type === 'company';
    },

    disabledDates() {
      return {
        referred: {
          to: this.incidentDateTime,
          from: new Date()
        },
        incident: {
          from: new Date()
        }
      };
    },

    incidentDateTime() {
      if (this.source_exists && this.form) {
        return window.DateManager.parse(this.form.incident_occurred_at);
      }

      return this.form ? this.form.incident_occurred_at : null;
    }
  },

  methods: {
    setActive(type) {
      this.referrer_type = type;
    },

    clearFormCompany() {
      this.form.referrer_id = null;
    },

    clearFormIndividual() {
      this.form.referrer_first_name = null;
      this.form.referrer_last_name = null;
      this.form.referrer_telephone = null;
    },

    mount() {
      window.Ajax.get('/companies?type=referrer')
        .then(response => {
          this.referrers = response.data;
        })
        .catch(response => {});

      window.Ajax.get('/incidents/' + this.incident + '/source')
        .then(response => {
          this.source_exists = true;
          this.form.claim_reference = response.data.claim_reference;
          this.form.source_reference = response.data.source_reference;
          if (response.data.incident_occurred_at) {
            this.setIncidentDate(
              window.DateManager.format(
                response.data.incident_occurred_at,
                'DD/MM/YYYY HH:mm'
              )
            );
          }
          this.form.referred_at = response.data.referred_at
            ? window.DateManager.format(response.data.referred_at)
            : null;
          this.form.referrer_id = response.data.referrer_id;
          this.form.referrer_first_name = response.data.referrer_first_name;
          this.form.referrer_last_name = response.data.referrer_last_name;
          this.form.referrer_telephone = response.data.referrer_telephone;
          this.form.referrer_email_address =
            response.data.referrer_email_address;

          if (response.data.referrer_id) {
            this.referrer_type = 'company';
          } else {
            if (
              response.data.referrer_first_name ||
              response.data.referrer_last_name ||
              response.data.referrer_telephone
            ) {
              this.referrer_type = 'individual';
            } else {
              this.referrer_type = 'none';
            }
          }

          this.$emit('exists');
        })
        .catch(error => {
          this.form.claim_reference = this.getSetting('claim_prefix');
        });
    },

    changeHandler() {
      if (!this.data_entered) {
        this.data_entered = true;
      }
      this.$emit('unsaved-data', this.data_entered);
    },

    submit() {
      if (this.source_exists) {
        this.makeRequest('put');
        // reset monitoring of form changes
        this.data_entered = false;
        this.$emit('unsaved-data', this.data_entered);
        return;
      }

      this.makeRequest('post');
      // reset monitoring of form changes
      this.data_entered = false;
      this.$emit('unsaved-data', this.data_entered);
    },

    makeRequest(method) {
      let type = this.referrer_type;

      if (type === 'company') {
        this.clearFormIndividual();
      }

      if (type === 'individual') {
        this.clearFormCompany();
      }

      if (type === 'none') {
        this.clearFormIndividual();
        this.clearFormCompany();
      }

      this.form[method]('/incidents/' + this.incident + '/source')
        .then(response => {
          if (!this.source_exists) {
            this.source_exists = true;
            this.$emit('created');
            window.toastify.success(
              'Success!',
              'You can now access the other tabs'
            );
          } else {
            window.toastify.success(
              'Saved',
              'The source was saved successfully!'
            );
          }
        })
        .catch(error => {
          window.toastify.error(
            'Error',
            'Sorry, there was an error creating the source'
          );
        });
    },

    setIncidentDate(value) {
      this.form.incident_occurred_at = value;
    },

    setReferredDate(value) {
      this.form.referred_at = value;
    }
  },

  watch: {
    $route(to, from) {
      this.mount();
    }
  }
};
</script>
